<template>
  <div class="d-flex flex-column p-3 border border-secondary-subtle rounded shadow-sm">
    <form class="row g-2" @submit.prevent="$emit('form-send')">
      <slot :edit="edit"/>
      <hr class="mb-1">
      <div class="d-flex gap-2">
        <button v-if="!edit && !noEdit" @click="edit=true" type="button" class="btn btn-outline-primary">Редактировать</button>
        <button v-if="edit" @click.prevent="onCancel" type="button" class="btn btn-outline-primary">Отменить</button>
        <slot name="actions" :edit="edit"/>
        <button v-if="!edit && backButton" @click="$router.go(-1)" type="submit" class="btn btn-primary px-4">{{ backButton }}</button>
        <button v-if="edit" @click.prevent="$emit('form-send')" type="submit" class="btn btn-primary px-4">ОК</button>
        <button v-if="!edit && !newMode && !noDelete" type="button" @click.prevent="onDelete" class="btn btn-outline-danger ms-auto">Удалить</button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  props: [
    "newMode",
    "noEdit",
    "noDelete",
    "backButton"
  ],
  emits: ["form-send", "form-delete"],
  data() {
    return {
      edit: null,
    }
  },

  created() {
    this.edit = this.newMode;
  },

  methods: {
    accept() {
      this.edit = false;
    },

    onCancel() {
      if (this.newMode) {
        this.$router.go(-1);
      } else {
        this.edit = false;
      }
    },

    onDelete() {
      if (confirm("Вы уверены?")) this.$emit('form-delete');
    }
  }

}
</script>
